import { useParams } from 'react-router-dom';

import { qrcodeAPIService } from '~/api/qrcode';
import { BackdropFullScreen } from '~/components/atoms/loader/BackdropFullScreen';
import { TextMockup } from '~/components/atoms/mockup-previews/TextMockup';
import { ConfirmNavigateModal } from '~/components/organisms/ConfirmNavigateModal';
import { QrcodeStylesEditor } from '~/components/organisms/QrcodeStylesEditor';
import { PREVIEW_BAR_VIEW_TYPE } from '~/constants/common';
import { QRCODE_STATIC_TYPE } from '~/constants/qr-code';
import useQrCodeData from '~/hooks/useQrCodeData';
import useQrCodeStylesData from '~/hooks/useQrCodeStylesData';
import { StaticQrContentLayout } from '~/pages/qrBuilder/p-static/components/static-qr-content-layout/StaticQrContentLayout';
import { useStaticQrStylesHandleClickStep } from '~/pages/qrBuilder/p-static/hooks/useStaticQrStylesHandleClickStep';
import { useStaticQrUpdateStyles } from '~/pages/qrBuilder/p-static/hooks/useStaticQrUpdateStyles';
import { StaticQrCodeData } from '~/types/qrCode';
import { isMobileResolution } from '~/utils/common';

export const StaticTextStyles = () => {
  const params = useParams();

  const { data: qrCode, isLoading: qrCodeIsLoading } = useQrCodeData<StaticQrCodeData>({ qrCodeId: params.id });
  const { data: qrCodeStyles, isLoading: isLoadingQrCodeStyles } = useQrCodeStylesData();

  const {
    isProcessing: isUpdateStyleProcessing,
    updateStylesHandler,
    removeImageHandler,
    addImageHandler,
  } = useStaticQrUpdateStyles({ id: params.id, mutationFn: qrcodeAPIService.updateStaticQrText });

  const { isProcessing: isStepProcessing, handleClickStep } = useStaticQrStylesHandleClickStep({
    qrId: params.id,
    mutationFn: qrcodeAPIService.updateStaticQrText,
    qrCodeStatus: qrCode?.status,
    qrStaticType: QRCODE_STATIC_TYPE.TEXT,
  });

  const isQrFetching = isLoadingQrCodeStyles || qrCodeIsLoading;

  return (
    <>
      <StaticQrContentLayout
        handleStep={handleClickStep}
        isNextProcessing={isStepProcessing}
        activeStep={2}
        qrCode={qrCode}
        isQrLoading={isUpdateStyleProcessing}
        mockup={<TextMockup message={qrCode?.content?.text} />}
        defaultView={PREVIEW_BAR_VIEW_TYPE.QRCODE}
        form={
          <BackdropFullScreen isLoading={isQrFetching}>
            <QrcodeStylesEditor
              // TODO
              // Inside the QR code, we have old code with poor state management,
              // so when the QR code is loaded, we need to drop all states to apply it
              // Fix it
              key={isQrFetching.toString()}
              onAddImage={addImageHandler}
              onRemoveImage={removeImageHandler}
              onUpdateStyles={updateStylesHandler}
              qrCode={qrCode}
              qrCodeStylesTemplates={qrCodeStyles}
              containerStyle={isMobileResolution ? { padding: 0 } : null}
            />
          </BackdropFullScreen>
        }
      />
      <ConfirmNavigateModal activeStep={2} />
    </>
  );
};
